import { render, staticRenderFns } from "./AgeAtFirstDiagnosisCount.vue?vue&type=template&id=24a3ae66&scoped=true"
import script from "./AgeAtFirstDiagnosisCount.vue?vue&type=script&lang=ts"
export * from "./AgeAtFirstDiagnosisCount.vue?vue&type=script&lang=ts"
import style0 from "./AgeAtFirstDiagnosisCount.vue?vue&type=style&index=0&id=24a3ae66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3ae66",
  null
  
)

export default component.exports